import { render, staticRenderFns } from "./QBulkJobDataTable.vue?vue&type=template&id=ba2702b6&scoped=true&"
import script from "./QBulkJobDataTable.vue?vue&type=script&lang=js&"
export * from "./QBulkJobDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QBulkJobDataTable.vue?vue&type=style&index=0&id=ba2702b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2702b6",
  null
  
)

export default component.exports